import BaseResource from '@/lib/data/resource/BaseResource'

export default class InterestRateSwapInputResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.rate = payload.rate ?? ''
  }

  /* PROPERTIES */

  /* METHODS */
}
